import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  stateroom: {
    padding: '0',

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    marginBottom: theme.spacing(3),
    '& .roomLength': {
      color: theme.palette.blue1,
      fontFamily: 'ProximaBold',
      fontSize: theme.typography.pxToRem(12),
      letterSpacing: theme.typography.pxToRem(2),
      paddingBottom: theme.typography.pxToRem(8),
      textTransform: 'uppercase',
    },
    '& .resNumber': {
      fontFamily: 'ProximaBold',
      fontSize: theme.typography.pxToRem(16),
      paddingBottom: theme.typography.pxToRem(0),
      paddingRight: theme.typography.pxToRem(41),

      [theme.breakpoints.down('md')]: {
        '&:first-of-type': {
          paddingBottom: theme.typography.pxToRem(11),
        },
      },
    },
    '& .info': {
      paddingTop: '2px',
    },
    '& .info span': {
      color: theme.palette.grey1,
      display: 'inline-block',
      lineHeight: theme.typography.pxToRem(12),
      padding: `0 ${theme.typography.pxToRem(11)}`,
      fontSize: theme.typography.pxToRem(14),
      borderRight: `solid 1px ${theme.palette.grey1}`,

      [theme.breakpoints.down('xs')]: {
        padding: '0 9px',
      },

      '&:last-child': {
        borderRight: 'none',
      },
    },
    '& .MuiPaper-root': {
      backgroundColor: theme.palette.grey4,
      display: 'flex',
      padding: '27px 24px',
      position: 'relative',

      '& span': {
        fontFamily: theme.typography.proxima.regular,
        [theme.breakpoints.down('md')]: {
          '&:first-of-type': {
            paddingLeft: '0',
          },
        },
      },

      [theme.breakpoints.down('md')]: {
        flexDirection: 'column',
      },

      [theme.breakpoints.down('xs')]: {
        padding: '27px 16px',
      },
    },
    '& .editButton': {
      color: theme.palette.blue2,
      fontFamily: theme.typography.proxima.regular,
      fontSize: theme.typography.pxToRem(14),
      height: theme.typography.pxToRem(23),
      position: 'absolute',
      paddingLeft: theme.typography.pxToRem(25),
      paddingTop: theme.spacing(0.375),
      right: '27px',
      width: 'auto',
      cursor: 'pointer',

      [theme.breakpoints.down('xs')]: {
        width: '20px',
        right: '15px',

        '& span': {
          display: 'none',
        },
      },

      '& svg': {
        height: '19px',
        position: 'absolute',
        left: '0',
        top: '3px',
        width: '19px',
      },
    },
  },
}));

export default useStyles;
